/* CG fresh time (R47, Oct 15 2026).
   1. Keeps "Pickup Time ISO" current. CGW#3743 went to Checkmate with a ready time two hours in the past
      because the cart kept the time from an earlier visit. For ASAP restaurant carts this re-stamps
      now + prep on load, every minute, when the tab comes back, and right before checkout, so express
      checkout (Apple Pay / Shop Pay) always carries a fresh time too.
   2. Scheduled carts whose time has already passed cannot check out until a new time is picked.
   3. Puts one plain line under every Check out button that tells the guest exactly what to tap in
      Shopify checkout, so pickup and delivery orders match what they chose on our site.
   R50 (Oct 17 2026): promise times are pickup about 15 min, delivery about 35 to 45 min. No "Ship" wording:
      restaurant orders are pickup or local delivery only. */
(function () {
  if (window.__cgFresh) return; window.__cgFresh = true;
  var PREP = (window.CGM_CONFIG && +window.CGM_CONFIG.prepMinutes) || 15;
  var DELIVERY_ETA = '35 to 45 min';
  var cart = null, busy = false;
  function off(ms) {
    try {
      var z = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', timeZoneName: 'shortOffset' }).formatToParts(new Date(ms)).filter(function (x) { return x.type === 'timeZoneName'; })[0].value;
      var m = z.match(/([+-])(\d{1,2})(?::(\d{2}))?/); if (m) return m[1] + ('0' + m[2]).slice(-2) + ':' + (m[3] || '00');
    } catch (e) {}
    return '-07:00';
  }
  function iso(ms) {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return p.year + '-' + p.month + '-' + p.day + 'T' + (p.hour === '24' ? '00' : p.hour) + ':' + p.minute + ':00' + off(ms);
  }
  function restaurant(c) { var a = (c && c.attributes) || {}; return c && c.item_count > 0 && a['Channel'] === 'restaurant' && a['Catering Order'] !== 'Yes'; }
  function asap(a) { return a['Order Timing'] === 'ASAP' || a['Requested Time'] === 'ASAP' || (!a['Order Timing'] && !a['Pickup Time ISO']); }
  function stale(a) { var t = Date.parse(a['Pickup Time ISO'] || ''); return isNaN(t) || Math.abs(t - (Date.now() + PREP * 60000)) > 3 * 60000; }
  function past(a) { var t = Date.parse(a['Pickup Time ISO'] || ''); return !isNaN(t) && t < Date.now() + 5 * 60000; }
  function save(attrs) {
    busy = true;
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; busy = false; paint(); return c; }, function () { busy = false; });
  }
  function refresh() {
    if (busy) return Promise.resolve(cart);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      cart = c; paint();
      if (!restaurant(c)) return c;
      var a = c.attributes || {};
      if (asap(a) && (stale(a) || a['Order Timing'] !== 'ASAP' || a['Requested Time'] !== 'ASAP')) return save({ 'Pickup Time ISO': iso(Date.now() + PREP * 60000), 'Order Timing': 'ASAP', 'Requested Time': 'ASAP', 'Scheduled Date': '', 'Scheduled Time': '' });
      return c;
    }).catch(function () { return cart; });
  }
  /* the line under Check out */
  function tip() {
    if (!restaurant(cart)) return '';
    var a = cart.attributes || {};
    if (!asap(a) && past(a)) return '<b>Your scheduled time has passed.</b> Pick a new time above to check out.';
    if (a['Order Type'] === 'Delivery') return '<b>Delivery:</b> at checkout choose <b>Delivery</b> and enter your address. ' + (asap(a) ? 'Arrives in about ' + DELIVERY_ETA + '.' : 'Arrives at the time you picked.');
    return '<b>Pickup:</b> at checkout choose <b>Pickup</b>. ' + (asap(a) ? 'We start it right away, ready in about ' + PREP + ' min.' : 'Ready at the time you picked.') + ' Shopify shows a standard "1 hour" note there, your order is ready at the time shown here.';
  }
  var SEL = '.cgm-panel .cgm-checkout, #checkout, #CartDrawer-Checkout';
  function paint() {
    var html = tip();
    document.querySelectorAll(SEL).forEach(function (b) {
      var host = b.parentNode; if (!host) return;
      var t = host.querySelector(':scope > .cg-co-tip');
      if (!html) { if (t) t.remove(); return; }
      if (!t) { t = document.createElement('p'); t.className = 'cg-co-tip'; b.insertAdjacentElement('afterend', t); }
      if (t.innerHTML !== html) t.innerHTML = html;
    });
  }
  /* last check right before checkout (runs before the other checkout handlers) */
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(SEL + ', [name="checkout"], a[href="/checkout"], a[href$="/checkout"]'); if (!b || !restaurant(cart)) return;
    var a = cart.attributes || {};
    if (!asap(a) && past(a)) {
      e.preventDefault(); e.stopImmediatePropagation(); paint();
      if (window.CG && window.CG.toast) window.CG.toast('Your scheduled time has passed. Pick a new time.');
      var s = document.getElementById('cg-scheduler') || document.querySelector('.cgm-pw'); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else if (window.CGMenu && window.CGMenu.openSetup) window.CGMenu.openSetup();
    }
  }, true);
  var css = document.createElement('style');
  css.textContent = '.cg-co-tip{margin:8px 0 0;font-size:13px;line-height:1.45;color:#4a4642;text-align:left}.cg-co-tip b{color:#1B1919}';
  (document.head || document.documentElement).appendChild(css);
  /* re-check after any cart change, on a timer and when the guest comes back to the tab */
  var of = window.fetch;
  if (of && !of.__cgFresh) {
    var w = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (!busy && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(function () { setTimeout(refresh, 500); }).catch(function () {});
      return p;
    };
    Object.keys(of).forEach(function (k) { w[k] = of[k]; }); w.__cgFresh = true; window.fetch = w;
  }
  setInterval(refresh, 60000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  var mt; new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(paint, 200); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
